import StickyAlertProps, {
  StickyAlertPropsSchema,
} from '@/modules/alerts/models/sticky-alert-props';
import { BANNER_VARIANT } from '@/constants/AppConstants';

export type BannerStickyAlertVariant = typeof BANNER_VARIANT[keyof typeof BANNER_VARIANT];

export interface BannerStickyAlertOptions {
  timeoutMs?: number;
}

/**
 * This is an interface because `defineProps` only works with interfaces.
 */
export interface BannerStickyAlertPropsSchema extends StickyAlertPropsSchema {
  variant: BannerStickyAlertVariant;

  message: string;

  options?: BannerStickyAlertOptions;
}

export default class BannerStickyAlertProps extends StickyAlertProps
  implements BannerStickyAlertPropsSchema {
  variant: BannerStickyAlertVariant;

  message: string;

  options?: BannerStickyAlertOptions;

  constructor(
    variant: BannerStickyAlertVariant,
    message: string,
    options?: BannerStickyAlertOptions,
  ) {
    super();
    this.variant = variant;
    this.message = message;
    this.options = options;
  }
}
